<template>
  <div class="ajax-loading-animation" v-if="running">
    <div class="line"></div>
    <div class="subline inc"></div>
    <div class="subline dec"></div>
  </div>
</template>

<script>
export default {
  props: [
    'top'
  ],
  computed: {
    running () {
      return this.$store.getters['general/ajax']
    }
  }
}
</script>
